// extracted by mini-css-extract-plugin
export var blogContainer = "category-module--blogContainer--1IM6N";
export var sidebarContainer = "category-module--sidebarContainer--ESjsD";
export var sidebar = "category-module--sidebar--299LO";
export var categoryTitle = "category-module--categoryTitle--2UAz8";
export var categoriesContainer = "category-module--categoriesContainer--1WOp6";
export var category = "category-module--category--g4NZg";
export var activeCategory = "category-module--activeCategory--s2C4x";